type tVector2 = [number, number];
type tVector4 = [number, number, number, number];

//

export function get3StarShare(episodeIndex: number) {
    const episode = `episode_${episodeIndex + 1}`;
    const key = `3starshare_${episode}`;
    const path = `resource/graphics/shares/3_stars/${key}.png`;
    return { key, path };
}

export function getMyPetMiniGameJackpotShare() {
    const key = `my_pet_mini_game_jackpot`;
    const path = `resource/graphics/shares/my_pet_mini_game/pet_minigame_jackpot_share.png`;
    return { key, path };
}

export function getFieldUnlockShare(fieldId: string) {
    const key = `${fieldId}_field_unlock`;
    const path = `resource/graphics/shares/fields/${key}.png`;
    return { key, path };
}

export function getCropUnlockShare(cropId: string) {
    const key = `${cropId}_crop_unlock_share`;
    const path = `resource/graphics/shares/crops/new_crop_${cropId}.png`;
    return { key, path };
}

export function getPetUnlockShare(petId: string) {
    const key = `${petId}_pet_unlock_share`;
    const path = `resource/graphics/shares/pets/${petId}_pet_unlock_share.png`;
    return { key, path };
}

export function getLuckyWheelShare(type: string) {
    const key = `spinwheel_${type}_share`;
    const path = `resource/graphics/shares/lucky_wheel/spinwheel_${type}_share.png`;
    return { key, path };
}

export function getHardLevelShareBorder() {
    const key = 'hard_level_share_border'
    const path = `resource/graphics/shares/hard_level/hard_level_share_border.png`;
    return { key, path };
}

export function getHardLevelShareClose() {
    const key = 'x_button'
    const path = `resource/graphics/shares/hard_level/x_button.png`;
    return { key, path };
}

export function getHardLevelShare() {
    const key = 'hard_level_fb_share'
    const path = `resource/graphics/shares/hard_level/hard_level_fb_share.png`;
    return { key, path };
}

//

const defaultThreeStarPerEpisode = {
    position: [289, 394] as tVector2,
    offsets: [-289, -394, -289, -394] as tVector4,
};

export const threeStarPerEpisode: ReadonlyArray<typeof defaultThreeStarPerEpisode> = [
    // World 1
    defaultThreeStarPerEpisode,
    { position: [824, 399], offsets: [-825, -399, -825, -399] },
    { position: [824, 399], offsets: [-820, -399, -820, -399] },
    { position: [289, 394], offsets: [-283, -394, -283, -394] },
    { position: [824, 399], offsets: [-820, -399, -820, -399] },
    { position: [824, 399], offsets: [-820, -399, -820, -399] },
    { position: [289, 394], offsets: [-283, -394, -283, -394] },

    // World 2
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 3
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 4
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 5
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 6
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 7
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 8
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 9
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 10
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 11
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 12
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 13
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 14
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 15
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 16
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 17
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 18
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,

    // World 19
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    
    // World 20
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
    defaultThreeStarPerEpisode,
];

//

const defaultPerCrop = {
    crop: [0.705, 0.55, 0.705, 0.55] as tVector4,
    field: [0.77, 0.55, 0.77, 0.55] as tVector4,
    fieldUnlock: [907, 337] as tVector2,
    cropUnlock: [805, 375] as tVector2,
    hardShare: [255, -30] as tVector2,
};

// FIXME
type CropId = string;

export const perCrop: Record<CropId, typeof defaultPerCrop> = {
    // World 1
    wheat: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 338],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    tomato: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    pumpkin: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    blueberry: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    apple: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.707, 0.55, 0.707, 0.55],
        fieldUnlock: [831, 337],
        cropUnlock: [805, 375],
        hardShare: [185, -30],
    },
    sunflower: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.707, 0.55, 0.707, 0.55],
        fieldUnlock: [831, 337],
        cropUnlock: [805, 375],
        hardShare: [185, -30],
    },
    lemon: {
        crop: [0.707, 0.55, 0.707, 0.55],
        field: [0.707, 0.55, 0.707, 0.55],
        fieldUnlock: [831, 337],
        cropUnlock: [805, 375],
        hardShare: [185, -30],
    },

    // World 2
    strawberry: {
        crop: [0.705, 0.55, 0.705, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    watermelon: {
        crop: [0.705, 0.55, 0.705, 0.55],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [914, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    orange: defaultPerCrop,
    artichoke: defaultPerCrop,
    cherry: defaultPerCrop,
    carrot: defaultPerCrop,

    // World 3
    grapes: defaultPerCrop,
    pear: defaultPerCrop,
    lavender: {
        crop: [0.705, 0.56, 0.705, 0.56],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [907, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    pepper: defaultPerCrop,

    // World 4
    onion: defaultPerCrop,
    cabbage: defaultPerCrop,
    olive: {
        crop: [0.705, 0.56, 0.705, 0.56],
        field: [0.77, 0.55, 0.77, 0.55],
        fieldUnlock: [907, 337],
        cropUnlock: [805, 375],
        hardShare: [255, -30],
    },
    eggplant: defaultPerCrop,

    // World 5
    corn: defaultPerCrop,
    pomegranate: defaultPerCrop,
    zucchini: defaultPerCrop,
    tangerine: defaultPerCrop,

    // World 6
    tulip: defaultPerCrop,
    calla: defaultPerCrop,
    daffodil: defaultPerCrop,
    peony: defaultPerCrop,

    // World 7
    redcabbage: defaultPerCrop,
    potato: defaultPerCrop,
    raspberry: defaultPerCrop,
    whiteasparagus: defaultPerCrop,

    // World 8
    cucumber: defaultPerCrop,
    pinenuts: defaultPerCrop,
    lettuce: defaultPerCrop,
    radish: defaultPerCrop,

    // World 9
    date: defaultPerCrop,
    barley: defaultPerCrop,
    almond: defaultPerCrop,
    honeymelon: defaultPerCrop,

    // World 10
    leek: defaultPerCrop,
    redcurrant: defaultPerCrop,
    cauliflower: defaultPerCrop,
    crowberry: defaultPerCrop,

    // World 11
    rice: defaultPerCrop,
    peach: defaultPerCrop,
    lychee: defaultPerCrop,
    greentea: defaultPerCrop,

    // World 12
    garlic: defaultPerCrop,
    peas: defaultPerCrop,
    quince: defaultPerCrop,
    bellpepper: defaultPerCrop,

    // World 13
    mint: defaultPerCrop,
    chamomile: defaultPerCrop,
    rosemary: defaultPerCrop,
    verbena: defaultPerCrop,

    // World 14
    plumelia: defaultPerCrop,
    macadamia: defaultPerCrop,
    taro: defaultPerCrop,
    konacoffee: defaultPerCrop,

    // World 15
    manuka: defaultPerCrop,
    lupine: defaultPerCrop,
    kowhai: defaultPerCrop,
    boysenberry: defaultPerCrop,

    // World 16
    ginger: defaultPerCrop,
    persimmon: defaultPerCrop,
    redplum: defaultPerCrop,
    wasabi: defaultPerCrop,

    // World 17
    chili: defaultPerCrop,
    papaya: defaultPerCrop,
    agave: defaultPerCrop,
    avocado: defaultPerCrop,

    // World 18
    cotton: defaultPerCrop,
    fig: defaultPerCrop,
    sugarbeet: defaultPerCrop,
    hazelnut: defaultPerCrop,

    // World 19
    oat: defaultPerCrop,
    plum: defaultPerCrop,
    squash: defaultPerCrop,
    chives: defaultPerCrop,

    // World 20
    soybeans: defaultPerCrop,
    banana: defaultPerCrop,
    cassava: defaultPerCrop,
    guarana: defaultPerCrop,
};

//

const defaultCropIconOffsetsPerWorld: ReadonlyArray<tVector4> = [
    [-785, -100, -785, -100],
    [-975, -100, -975, -100],
    [-785, -240, -785, -240],
    [-975, -240, -975, -240],
];

export const cropIconOffsetsPerWorld: ReadonlyArray<typeof defaultCropIconOffsetsPerWorld> = [
    // World 1
    [
        [-720, -130, -720, -130], // wheat 0
        [-850, -120, -850, -120], // tomato 1
        [-1010, -150, -1010, -150], // pumpkin 2
        [-720, -280, -720, -280], // apple
        [-860, -350, -860, -350], // sunflower 4
        [-870, -240, -870, -240], // blueberry
        [-1020, -300, -1020, -300], // lemon 6
    ],
    // World 2
    [
        [-720, -100, -720, -100],
        [-870, -100, -870, -100],
        [-1035, -100, -1035, -100],
        [-720, -240, -720, -240],
        [-870, -240, -870, -240],
        [-1035, -240, -1035, -240],
    ],
    // World 3
    defaultCropIconOffsetsPerWorld, // Grape, Pear, Lavender, Pepper
    // World 4
    defaultCropIconOffsetsPerWorld, // Onion, Cabbage, Olive, Eggplant
    // World 5
    defaultCropIconOffsetsPerWorld, // Corn, Pomegranate, Zucchini, Tangerine
    // World 6
    defaultCropIconOffsetsPerWorld, // Tulip, Calla, Daffodil, Peony
    // World 7
    defaultCropIconOffsetsPerWorld, // Red Cabbage, Potato, Raspberry, White Asparagus
    // World 8
    defaultCropIconOffsetsPerWorld, // Cucumber, Pine Nuts, Lettuce, Radish
    // World 9
    defaultCropIconOffsetsPerWorld, // Date, Barley, Almond, HoneyMelon
    // World 10
    defaultCropIconOffsetsPerWorld, // Leek, Redcurrant, Cauliflower, Crowberry
    // World 11
    defaultCropIconOffsetsPerWorld, // Rice, Peach, Lychee, Green Tea
    // World 12
    defaultCropIconOffsetsPerWorld, // Garlic, Peas, Quince, Bell Pepper
    // World 13
    defaultCropIconOffsetsPerWorld, // Mint, Chamomile, Rosemary, Verbena
    // World 14
    defaultCropIconOffsetsPerWorld, //Plumelia, Macadamia, Taro, Konacoffee
    // World 15
    defaultCropIconOffsetsPerWorld, //boysenberry, kowhai, lupine, manuka
    // World 16
    defaultCropIconOffsetsPerWorld, //ginger, persimmon, red_plum, wasabi
    // World 17
    defaultCropIconOffsetsPerWorld, //chili, papaya, agaves, avocados
    // World 18
    defaultCropIconOffsetsPerWorld, //cotton, fig, sugarbeet, hazelnut
    // World 19
    defaultCropIconOffsetsPerWorld, //oat, plum, squash, chives
    // World 20
    defaultCropIconOffsetsPerWorld, //soybeans, banana, cassava, guarana
];
